import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { FlowDownstreamMetricsQueryVariables, FlowDownstreamMetricsQuery, MetricsDisplayGridRowDataFragment, FlowDownstreamMetricsFilteredByFlowOutputFieldQueryVariables, FlowDownstreamMetricsFilteredByFlowOutputFieldQuery, MetricSortOrder , FlowDownstreamMetricsFilteredByFlowOutputFieldDocument , FlowDownstreamMetricsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import { getRowDataForMetric, MetricsDisplayGrid, MetricsDisplayGridRowData } from '../sharedDisplayGrid/MetricsDisplayGrid';
import { MetricsValidSortFields } from '../sorting/sortProviders/MetricsGridSortProvider';

type QueryVariables = FlowDownstreamMetricsQueryVariables;
type QueryResults = FlowDownstreamMetricsQuery;
type QueryResultListNode = MetricsDisplayGridRowDataFragment;
type GridRowData = MetricsDisplayGridRowData;

type QueryVariablesWithFilter = FlowDownstreamMetricsFilteredByFlowOutputFieldQueryVariables;
type QueryResultsWithFilter = FlowDownstreamMetricsFilteredByFlowOutputFieldQuery;
type QueryResultListNodeWithFilter = MetricsDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  return flow ? flow.downstreamMetricsConnection : null;
}


function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  const flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
  const field = flowOutputFields && flowOutputFields[0];
  return field ? field.downstreamMetricsConnection : null;
}

export type FlowDownstreamMetricsQueryGridProps =
  GridSortProps<MetricsValidSortFields> & {
    readonly flowVizportalUrlId: string;
    readonly filteredFlowOutputFieldId: string | null;
    readonly rowCount: number | null;
  };

export function FlowDownstreamMetricsQueryGrid(props: FlowDownstreamMetricsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamMetricsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredMetricsLineageGridMessage();

  return (
    props.filteredFlowOutputFieldId ? (
      // Query with Selected Field as Filter
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={FlowDownstreamMetricsFilteredByFlowOutputFieldDocument}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
          orderBy: props.orderBy as MetricSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForMetric}
      >
        {({ rowStore }) => <MetricsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    ) : (
      // Query without Selection
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={FlowDownstreamMetricsDocument}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          orderBy: props.orderBy as MetricSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForMetric}
      >
        {({ rowStore }) => <MetricsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    )
  )
}
